import React from 'react';

interface TradeInHeaderProps {
  currentStep: number;
}

const TradeInHeader: React.FC<TradeInHeaderProps> = ({ currentStep }) => {
  const steps = ['Vehicle Information', 'Vehicle Options', 'Vehicle Condition', 'Personal Information'];

  return (
    <ul className='wizard-step list-unstyled with-tb-space hide-scrollbar'>
      {steps.map((step, index) => (
        <li key={index} className={index <= currentStep ? 'current' : ''}>
          {step}
        </li>
      ))}
    </ul>
  );
};

export default TradeInHeader;
